// extracted by mini-css-extract-plugin
module.exports = {"varAdditional01Extra400":"var(--tkww-union-color-additional-01extra-400, #0073E6)","btn":"btn--c047c","icon":"icon--d4086"};